module.exports = __webpack_public_path__ + "static/media/1013027.7048a032.jpg";